import { WireNameValue } from 'scenes/common/api/quote/types/nameValue.types';

export enum WireVehicleValueType {
  Market = 'MarketValue',
  Agreed = 'AgreedValue',
}

export enum WireUnderFinance {
  NoFinance = 'Nofin',
  SecuredLoan = 'PerSec',
  UnsecuredLoan = 'PerUnsec',
  Lease = 'Lease',
  HirePurchaseArrangement = 'Hirepur',
  Unspecified = '',
}

export enum OtherAttributes {
  UNDERFINANCE = 'UNDERFINANCE',
  MORTGAGE = 'MORTGAGE',
  VEHICLESECURITY = 'VEHICLESECURITY',
  IS_USED_FOR_BUSINESS = 'BUSINESS',
  RUST = 'RUST',
  HAIL_DAMAGE = 'HAILDAMAGE',
  OTHER_DAMAGE = 'OTHERDAMAGE',
  NON_STANDARD = 'NONSTANDARD',
  VEHICLE_MODIFICATION_STEREO = 'MODSTEREO',
}

export const preExistingDamages = [
  OtherAttributes.HAIL_DAMAGE,
  OtherAttributes.OTHER_DAMAGE,
  OtherAttributes.RUST,
];

type WireVehicleValues = {
  market: number;
  lowAgreed: number;
  highAgreed: number;
  agreed: number;
  selected: WireVehicleValueType;
};

type RegoLookupStatus = {
  success: number;
  failure: number;
};

export enum VehicleProviderType {
  Internal = 'Internal',
  Motorweb = 'Motorweb',
}

type WireRego = {
  number: string;
  lookup?: RegoLookupStatus;
  providerType: VehicleProviderType;
};

type WireVehicle = {
  id: string;
  addressRefId: string;
  partyRefIds: string[];
  year: string;
  make: string;
  model: string;
  type: string;
  engine: string;
  code: string;
  nvic: string;
  rego?: WireRego; // Not present when not yet set
  otherAttributes: WireNameValue[];
  coverageRefId: string[];
  modifications: WireNameValue[];
};

export type WireVehicleRequest = WireVehicle;

export type WireVehicleResponse = WireVehicle & {
  values: WireVehicleValues;
  modifications: WireNameValue[];
};
